import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Incident } from 'src/app/api/incidents.service';
import { LinkReportModes, OnLinkValues } from '../../link-report/link-report.component';

@Component({
    selector: 'app-link-report-modal',
    templateUrl: './link-report-modal.component.html',
    styleUrls: ['./link-report-modal.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkReportModalComponent implements OnInit {

  incidents: Incident[] = [];
  childIncidentId: number = -1;
  linkMode: LinkReportModes = LinkReportModes.Link;

  constructor(
    public modalRef: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    if (!config.data.incidents) throw new Error("incidents must be provided to the Link Report mdoal")
    if (!config.data.childIncidentId) throw new Error("childIncidentId must be provided to the Link Report modal")
    if (!config.data.linkMode) throw new Error("linkMode must be provided to the Link Report modal")

    this.incidents = config.data.incidents
    this.childIncidentId = config.data.childIncidentId
    this.linkMode = config.data.linkMode

  }

  ngOnInit(): void {
  }

  onLink(result: OnLinkValues) {

    this.modalRef.close(result);
  }

}
